
import Pagination from "@components/base/pagination/CenterPagination.vue";
import {
  Vue,
  Component,
  Prop,
  PropSync,
  Watch,
  Inject,
} from "vue-property-decorator";
import { Action, Getter, State } from "vuex-class";
import { deepClone } from "@/common/utils";
import { allDistrict, getDeptNumber, dicItem } from "@/api/common";
import {
  deleteSubscribe,
  enableOrDisable,
  getDetailById,
  updateItem,
} from "@/api/account";
@Component({
  name: "Subscribe",
  components: { Pagination },
})
export default class Subscribe extends Vue {
  @State("directCityList") private directCityList: any;
  @Getter("id") private id!: string;
  @Action("account/deleteSubscribeSetting") private deleteSubscribeSetting: any;
  @Action("account/updateSubscribe") private updateSubscribe: any;
  @Action("account/addSubscribe") private addSubscribe: any;
  @Action("account/getSubscribeList") private getSubscribeList: any;
  @Action("account/getSubscribeSetList") private getSubscribeSetList: any;
  handleDelete(id: any) {
    let formData = new FormData();
    formData.append("ids", id);
    deleteSubscribe(formData).then((res: any) => {
      if (res.data.code === 200) {
        this.$message.success("删除订阅设置成功");
        this.getData();
      } else {
        this.$message.warning("删除失败,请重试!");
      }
    });
  }
  active: any = 0;
  base_apply_direction: any = 65;
  setting: any = [];
  tableData: any = [];
  title: any = "修改订阅";
  inputVisible: any = false;
  inputValue: any = "";
  isSubscribed: Boolean = false;
  isUpdate: Boolean = false;
  dialogVisible: Boolean = false;
  dialogAddVisible: Boolean = false;
  keyOption: any = [];
  departOption: any = [];
  areaOption: any = [];
  areaList: any = [];
  departList: any = [];
  keyList: any = [];
  checkList: any = [];
  currentData: any = {};
  allArea = this.$root.$data.areaOption;
  mapData: any = [];
  deptArr: any = [];
  name: any = "";
  regionId: any = [];
  deptIds: any = "";
  columnIds: any = [];
  keywords: any = [];
  dicData: any = [];
  pages = 0;
  total = 0;
  size = 10;
  current = 1;
  subscribeId = "";
  regionNames = "";
  multipleSelection: any = [];
  constDepart = [
    { label: "湖北省", value: "420000" },
    { label: "国家", value: "100000" },
  ];
  created() {
    this.getData();
    allDistrict().then((res) => {
      res.data.result.shift();
      this.mapData = this.getTreeData(res.data.result);
    });
    dicItem("admin_subscribe_column").then((res) => {
      this.dicData = res.data.result;
    });
  }
  getTreeData(data: any) {
    for (var i = 0; i < data.length; i++) {
      if (data[i].children.length < 1) {
        // children若为空数组，则将children设为undefined
        data[i].children = undefined;
      } else {
        // children若不为空数组，则继续 递归调用 本方法
        this.getTreeData(data[i].children);
      }
    }
    return data;
  }
  handleChange(value: any) {
    this.deptIds = [];
    this.getDeptData(value);
    let selectArr = this.$refs["cascader"].getCheckedNodes()[0].pathLabels;
    if (selectArr.length > 0) {
      this.regionNames = selectArr.join(",");
    }
  }
  async getDeptData(id: any) {
    const res: any = await getDeptNumber(id);
    this.deptArr = res.data.result;
  }
  handleEdit(item: any) {
    this.subscribeId = item.id;
    this.deptIds = [];
    this.getDeptData(item.regionId);
    getDetailById({ id: item.id }).then((res) => {
      this.dialogAddVisible = true;
      if (res.data.result && res.data.result.deptList) {
        res.data.result.deptList.forEach((item: any) => {
          this.deptIds.push(item.deptId);
        });
        this.regionNames = res.data.result.regionNames;
        console.log(this.deptIds, "this.deptIds");
      }
    });
    this.name = item.name;
    this.regionId = item.regionId;

    this.columnIds = item.columnIds.split(",");
    this.keywords = item.keywords.split(",");
    this.title = "修改订阅";
  }
  async handleAdd(item: any) {
    this.name = "";
    this.regionId = "";
    this.deptIds = "";
    this.columnIds = "";
    this.keywords = [];
    this.dialogAddVisible = true;
    this.title = "新增订阅";
  }
  handleClose() {
    this.dialogVisible = false;
    this.dialogAddVisible = false;
  }
  handleCommand(command: any) {
    this.active = command;
  }
  handleCloseProvince(tag: any) {
    const { areaList, departmentList } = this.currentData;
    areaList.splice(areaList.indexOf(tag), 1);
    this.deptArr = departmentList.filter((province: any) => {
      return province.value !== tag.value;
    });
  }
  async resetCurrent() {
    const tempArea = deepClone(this.allArea);
    const areaOptionForDepart = deepClone(tempArea);
    const areaOptionForArea = deepClone(tempArea);
    this.currentData.areaList = areaOptionForArea;
    this.deptArr = areaOptionForDepart;
  }
  async update() {
    const tempArea = deepClone(this.allArea);
    this.areaOption = deepClone(tempArea);
    this.isUpdate = true;
  }
  handleCloseCityDepart(province: any, city: any, tag: any) {
    const { departmentList } = this.currentData;
    this.deptArr = departmentList.map((provinceItem: any) => {
      if (provinceItem.value === province.value) {
        provinceItem.children = provinceItem.children.map((cityItem: any) => {
          if (cityItem.value === city.value) {
            cityItem.depart = cityItem.depart.filter((cityDepart: any) => {
              return cityDepart.value !== tag.value;
            });
          }
          return cityItem;
        });
      }
      return provinceItem;
    });
  }
  handleCloseCity(province: any, tag: any) {
    const { areaList } = this.currentData;
    this.currentData.areaList = areaList.map((provinceItem: any) => {
      if (provinceItem.value === province.value) {
        provinceItem.children = provinceItem.children.filter(
          (cityItem: any) => {
            return cityItem.value !== tag.value;
          }
        );
      }
      return provinceItem;
    });
    const { departmentList } = this.currentData;
    this.deptArr = departmentList.map((provinceItem: any) => {
      if (province.value === provinceItem.value) {
        provinceItem.children = provinceItem.children.filter(
          (cityItem: any) => {
            return cityItem.value !== tag.value;
          }
        );
      }
      return provinceItem;
    });
  }
  handleCloseArea(province: any, city: any, tag: any) {
    this.areaOption = this.areaOption.map((provinceItem: any) => {
      if (provinceItem.value === province.value) {
        provinceItem.children = provinceItem.children.map((cityItem: any) => {
          if (cityItem.value === city.value) {
            cityItem.children = cityItem.children.filter((areaItem: any) => {
              return areaItem.value !== tag.value;
            });
          }
          return cityItem;
        });
      }
      return provinceItem;
    });
  }
  handleCloseAreaDepart(province: any, city: any, area: any, tag: any) {
    this.areaOption = this.areaOption.map((provinceItem: any) => {
      if (provinceItem.value === province.value) {
        provinceItem.children = provinceItem.children.map((cityItem: any) => {
          if (cityItem.value === city.value) {
            cityItem.children = cityItem.children.map((areaItem: any) => {
              if (areaItem.value === area.value) {
                areaItem.depart = areaItem.depart.filter((areaDepart: any) => {
                  return areaDepart.id !== tag.id;
                });
              }
              return areaItem;
            });
          }
          return cityItem;
        });
      }
      return provinceItem;
    });
  }
  showInput() {
    this.inputVisible = true;
    this.$nextTick(() => {
      (this.$refs.saveTagInput as any).$refs.input.focus();
    });
  }
  handleCloseKey(tag: any) {
    this.keywords = this.keywords.filter((item: any) => {
      return item !== tag;
    });
  }
  handleInputConfirm() {
    let inputValue = this.inputValue;

    // 判断当前的key是否存在
    const filterKey = this.keywords.filter((item: any) => item == inputValue);
    if (inputValue && filterKey.length === 0) {
      // setting[active].keyList
      this.keywords.push(inputValue);
    } else {
      if (filterKey.length > 0) {
        this.$message.warning("已存在相同的关键字!");
      }
    }
    this.inputVisible = false;
    this.inputValue = "";
  }
  areaId: any = "";
  departId: any = "";
  keyId: any = "";
  async addSetting() {
    const { name, regionId, deptIds, columnIds, keywords } = this;

    const options: any = {
      name,
      regionId,
      deptIds: deptIds.join(","),
      columnIds: columnIds.join(","),
      keywords: keywords,
      regionNames: this.regionNames,
    };

    if (
      columnIds.length == 0 ||
      deptIds.length == 0 ||
      keywords.length == 0 ||
      !name ||
      !regionId
    ) {
      return this.$message.warning("无法订阅空设置");
    }
    let formdata = new FormData();
    for (let key in options) {
      console.log(key, options[key], 9999);
      formdata.append(key, options[key]);
    }
    if (this.subscribeId) {
      formdata.append("id", this.subscribeId);
      updateItem(formdata)
        .then((res: any) => {
          if (res.data.code === 200) {
            this.handleClose();
            this.isUpdate = false;
            this.getData();
            return this.$message.success("修改成功");
          }
          return false;
        })
        .catch(() => this.handleClose());
    } else {
      this.addSubscribe(formdata)
        .then((res: any) => {
          if (res.code === 200) {
            this.handleClose();
            this.isUpdate = false;
            this.getData();
            return this.$message.success("订阅成功");
          }
          return false;
        })
        .catch(() => this.handleClose());
    }
  }
  async getData() {
    const options = {
      pageNumber: this.current,
      pageSize: this.size,
    };
    this.getSubscribeSetList(options).then((res: any) => {
      const { code, result, msg } = res;
      if (code === 200 && result) {
        let { records, total, pages } = result;
        this.total = total;
        this.pages = pages;

        this.tableData = records;
      }
    });
  }
  showDialog() {
    this.dialogVisible = true;
    this.title = "新增订阅";
  }
  showUpdateDialo() {
    this.dialogVisible = true;
    this.title = "修改订阅";
  }
  updateData() {
    const { id, keyList, areaList, departmentList, creationTime } =
      this.currentData;
    const areaOption: any = [];
    const departOption: any = [];
    const keyOption: any = [];

    departmentList.map((province: any) => {
      province.depart.map((provinceDepart: any) => {
        departOption.push(provinceDepart.id);
        return provinceDepart;
      });
      province.children.map((city: any) => {
        city.depart.map((cityDepart: any) => {
          departOption.push(cityDepart.id);
        });
        return city;
      });
      return province;
    });

    areaList.map((province: any) => {
      areaOption.push(province.value);
      province.children.map((city: any) => {
        areaOption.push(city.value);
        return city;
      });
      return province;
    });
    keyList.map((key: any) => {
      keyOption.push(key.label);
      return key;
    });
    const departSubscribeData = departOption.join(",");
    const areaSubscribeData = areaOption.join(",");
    const keySubscribeData = keyOption.join(",");
    const options: any = [
      {
        departmentId: departSubscribeData,
        addressCode: areaSubscribeData,
        title: keySubscribeData,
        userId: this.id,
        id,
        creationTime,
      },
    ];
    if (!departSubscribeData && !areaSubscribeData && !keySubscribeData) {
      return this.$message.warning("无法订阅空设置");
    }
    this.updateSubscribe(options).then(({ code, data }: any) => {
      if (code === 0 && data) {
        this.getData();
        this.isUpdate = false;
        this.handleClose();
        return this.$message.success("订阅成功");
      }
      return false;
    });
  }
  handleCurrentChange(val: any) {
    this.current = val;
    this.getData();
  }
  changeStatus(item: any) {
    let formData = new FormData();
    formData.append("ids", item.id);
    formData.append("isEnable", item.isEnable == 1 ? 0 : 1);
    enableOrDisable(formData).then((res: any) => {
      if (res.data.code == 200) {
        this.$message.success("设置成功");
        this.getData();
      } else {
        this.$message.warning("失败,请重试!");
      }
    });
  }
  handleSelectionChange(val: any) {
    let multipleArr = [];
    if (val && val.length > 0) {
      val.forEach((item: any) => {
        multipleArr.push(item.id);
      });
    }
    this.multipleSelection = val;
  }
}
